import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { ShowCombinedReportsResolver } from './show-combined-reports.resolver';

export class CombinedReportsRouteDefinition {
  public static getRoutes(): RouteDefinition {
    const routes = {
      path: RoutePaths.COMBINED_REPORTS,
      title: 'Location Reports',
      icon: 'icon-establishments.svg',
      position: 3,
      resolver: ShowCombinedReportsResolver,
      children: [
        {
          path: RoutePaths.REVENUE_OVERVIEW,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'Location Revenue',
          position: 0
        },
        {
          path: RoutePaths.RECEIPT,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'All Receipts',
          position: 1
        },
        {
          path: RoutePaths.DAY,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'All Day Reports',
          position: 2
        },
        {
          path: RoutePaths.WEEK,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'All Week Reports',
          position: 3
        },
        {
          path: RoutePaths.MONTH,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'All Month Reports',
          position: 4
        },
        {
          path: RoutePaths.PRODUCT,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'All Products Reports',
          position: 5
        },
        {
          path: RoutePaths.CATEGORY,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'All Categories Reports',
          position: 6
        },
        {
          path: RoutePaths.USERS,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'All Users Reports',
          position: 7
        },
        {
          path: RoutePaths.REVENUE,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'All Revenue Reports',
          position: 8
        },
        {
          path: RoutePaths.SUMMARY,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'Summary Report',
          position: 9
        },
        {
          path: RoutePaths.EXPORT_DATA,
          parentPath: RoutePaths.COMBINED_REPORTS,
          title: 'Export Data',
          position: 10
        }
      ]
    };

    return routes;
  }
}
